import * as c from "./constant";

export const setLoading = val => ({
  type: c.loading,
  payload: val
});
